export default "__VITE_ASSET__86a7fdc5__"